import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MediaItem } from '../../api/models/media-item';

@Pipe({
  name: 'imagePipe',
})
export class ImagePipe implements PipeTransform {
  transform(
    value: MediaItem | undefined,
    type:
      | 'user'
      | 'registry'
      | 'registry_card'
      | 'topbar'
      | 'user-w'
      | 'travel'
      | 'user-grey-bg' = 'user',
    //args: {
    //type: 'user' | 'registry' | 'topbar' | 'user-w',
    size: 'sm' | 'md' | 'lg' | undefined
    //}
  ): any {
    if (value && value.path) {
      if (value.path.startsWith('https') && value.path.includes('google')) {
        let googlePicSize = 's300-c';
        if (size === 'sm') {
          googlePicSize = 's120-c';
        }
        if (size === 'md') {
          googlePicSize = 's400-c';
        }
        if (size === 'lg') {
          googlePicSize = 's800-c';
        }
        return (
          value.path.substring(0, value.path.lastIndexOf('s96-c')) +
          googlePicSize
        );
      } else {
        const lastDotIndex = value.path.lastIndexOf('.');
        if (
          value.path.startsWith('https') &&
          value.path.includes('images.unsplash.com')
        ) {
          let width = 1200;
          if (size === 'sm') width = 400;
          if (size === 'md') width = 800;
          if (size === 'lg') width = 1200;

          const separator = value.path.includes('?') ? '&' : '?';
          return `${value.path}${separator}auto=format&fit=crop&w=${width}&q=70`;
        }
        if (size === 'sm') {
          const newFilePath =
            value.path.slice(0, lastDotIndex) +
            '-sm' +
            value.path.slice(lastDotIndex);
          return newFilePath.startsWith('https')
            ? newFilePath
            : environment.mediaUrl + '/' + newFilePath;
        }
        if (size === 'md') {
          const newFilePath =
            value.path.slice(0, lastDotIndex) +
            '-md' +
            value.path.slice(lastDotIndex);
          return newFilePath.startsWith('https')
            ? newFilePath
            : environment.mediaUrl + '/' + newFilePath;
        }
        if (size === 'lg') {
          const newFilePath =
            value.path.slice(0, lastDotIndex) +
            '-lg' +
            value.path.slice(lastDotIndex);
          return newFilePath.startsWith('https')
            ? newFilePath
            : environment.mediaUrl + '/' + newFilePath;
        }
      }
      return value.path.startsWith('https')
        ? value.path
        : environment.mediaUrl + '/' + value.path;
    }
    switch (type) {
      case 'user':
        return `/assets/media/icons/user-big.png`;
      case 'user-w':
        return `/assets/media/icons/user-big-w.png`;
      case 'topbar':
        return `/assets/media/icons/user.png`;
      case 'registry':
        return `/assets/media/imgs/logo-st-small.png`;
      case 'registry_card':
        return `/assets/media/imgs/reg_placeholder_card.png`;
      case 'travel':
        return `/assets/media/imgs/travel-photos.png`;
      case 'user-grey-bg':
        return `/assets/media/icons/user-placeholder.png`;
      default:
        return `/assets/media/icons/user-big.png`;
    }
  }
}
